import React from 'react'
import { Carousel } from 'react-bootstrap'
import sliderData from "../../utils/data/home/SlideData.json";

function Slider() {
    return (
        <div>
            <Carousel variant="dark">
                {
                    sliderData.map((d) => (
                        <Carousel.Item>
                            <img
                                className="slider_img"
                                src={d.img}
                                alt="Loading.."
                            />
                            <Carousel.Caption className='slider_cap' >
                                <h5 className='slider_cap_title_one'> {d.titleOne} </h5>
                                <h5 className='slider_cap_title' > {d.title} </h5>
                                <p className='slider_cap_text'> {d.text} </p>
                            </Carousel.Caption>
                        </Carousel.Item>
                    ))
                }
            </Carousel>
        </div>
    )
}

export default Slider